import React, { Component } from 'react'
import FileSaver from 'file-saver'
import AvatarEditor from 'react-avatar-editor'
import { Input, Select, Row, Col, Button, Modal, Slider, Alert } from 'antd'
import { wrapText, countLineWrapText } from '../utils'
import haewonCardPic from '../img/card_haewon.png'
import peceraCardPic from '../img/card_pecera.png'
import toothpasteCardPic from '../img/card_toothpaste.png'
import dropshipPic from '../img/dropship.png'
import juniorPic from '../img/junior.png'
import seniorPic from '../img/senior.png'
import vipPic from '../img/vip.png'
import supervipPic from '../img/supervip.png'

class DetailForms extends Component {
  state = {
    fileSelected: null,
    image: null,
    fields: {
      idhw: '',
      name: '',
      fb: '',
      line: '',
      ig: '',
      tel: '',
      zone: ''
    },
    rank: 'dropship',
    product: 'haewon',
    croppedImage: null,
    croppedImageInfo: {
      width: 0,
      height: 0
    },
    modalVisible: false,
    rotate: 0,
    picScale: 1.2,
    saveBlob: null,
    readyDownload: false
  }

  showModal = () => {
    this.setState({
      modalVisible: true
    })
  }

  handleOk = e => {
    console.log(e)
    if (this.editor) {
      const cropImagecanvas = this.editor.getImage()
      const croppedImageInfo = {
        width: 0,
        height: 0
      }
      const upperThis = this
      const img = new Image()
      const dataUrlImage = cropImagecanvas.toDataURL()
      img.onload = function() {
        console.log(`width : ${this.width} height: ${this.height}`)
        croppedImageInfo.width = this.width
        croppedImageInfo.height = this.height
        upperThis.setState(() => ({
          croppedImageInfo,
          croppedImage: dataUrlImage,
          modalVisible: false
        }))
      }
      img.src = dataUrlImage
    }
  }

  handleCancel = e => {
    console.log(e)
    this.setState({
      modalVisible: false
    })
  }

  setImageEditorRef = editor => (this.editor = editor)

  rotateClockwise = () => {
    this.setState(prevState => {
      if (prevState.rotate === 270) {
        return { rotate: 0 }
      }
      return { rotate: prevState.rotate + 90 }
    })
  }

  changeZoom = v => {
    this.setState({
      picScale: 1 + v / 100
    })
  }

  onRankChange = rank => this.setState(() => ({ rank }))

  onProductChange = product => this.setState(() => ({ product }))

  renderLabel = text => {
    return (
      <Col
        xs={{ span: 3 }}
        md={{ span: 5 }}
        xl={{ span: 7 }}
        style={{ textAlign: 'right' }}
      >
        {text}
      </Col>
    )
  }

  renderSelectProduct = () => {
    return (
      <div style={{ marginTop: 16 }}>
        <Row>
          {this.renderLabel('เลือกสินค้า')}
          <Col
            xs={{ span: 18, offset: 1 }}
            md={{ span: 12, offset: 1 }}
            xl={{ span: 8, offset: 1 }}
          >
            <Select
              defaultValue="haewon"
              onChange={this.onProductChange}
              style={{ width: 220, fontSize: '20px' }}
            >
              <Option style={{ fontSize: '20px' }} value="haewon">
                Haewon
              </Option>
              <Option style={{ fontSize: '20px' }} value="pecera">
                Pecera
              </Option>
              <Option style={{ fontSize: '20px' }} value="toothpaste">
                Toothpaste
              </Option>
            </Select>
          </Col>
        </Row>
      </div>
    )
  }

  renderSelectPosition = () => {
    const Option = Select.Option
    return (
      <div style={{ marginTop: 16 }}>
        <Row>
          {this.renderLabel('ตำแหน่ง')}
          <Col
            xs={{ span: 18, offset: 1 }}
            md={{ span: 12, offset: 1 }}
            xl={{ span: 8, offset: 1 }}
          >
            <Select
              defaultValue="dropship"
              onChange={this.onRankChange}
              style={{ width: 220, fontSize: '20px' }}
            >
              <Option style={{ fontSize: '20px' }} value="dropship">
                Drop Ship
              </Option>
              <Option style={{ fontSize: '20px' }} value="junior">
                Junior
              </Option>
              <Option style={{ fontSize: '20px' }} value="senior">
                Senior
              </Option>
              <Option style={{ fontSize: '20px' }} value="vip">
                VIP
              </Option>
              <Option style={{ fontSize: '20px' }} value="supervip">
                Super VIP
              </Option>
            </Select>
          </Col>
        </Row>
      </div>
    )
  }

  onFieldChange = (e, name) => {
    const newVal = e.target.value
    this.setState(prevState => ({
      fields: {
        ...prevState.fields,
        [name]: newVal
      }
    }))
  }

  TextInput = ({ label, placeholder, name }) => {
    const value = this.state.fields[name]
    return (
      <div style={{ marginTop: 16 }} key={name}>
        <Row>
          {this.renderLabel(label)}
          <Col
            xs={{ span: 18, offset: 1 }}
            md={{ span: 12, offset: 1 }}
            xl={{ span: 8, offset: 1 }}
          >
            <Input
              size="large"
              className="input-text"
              placeholder={placeholder}
              value={value}
              onChange={e => this.onFieldChange(e, name)}
            />
          </Col>
        </Row>
      </div>
    )
  }

  selectImage = e => {
    e.persist()
    console.log(e.target.files)
    if (e.target.files.length > 0) {
      const fileSelected = e.target.files[0]
      this.setState(() => ({
        fileSelected,
        modalVisible: true,
        rotate: 0,
        picScale: 1.2
      }))
    } else {
      this.setState(() => ({ fileSelected: null, croppedImage: null }))
    }
  }

  generateCard = () => {
    console.log('state : ', this.state)
    const fileSelected = this.state.fileSelected
    if (fileSelected) {
      const { idhw, name, fb, line, ig, tel, zone } = this.state.fields
      const { rank, croppedImageInfo } = this.state
      const ctx = document.getElementById('canvas').getContext('2d')
      ctx.imageSmoothingQuality = 'high'
      const canvas = document.getElementById('canvas')
      const cardImg = new Image()
      switch (this.state.product) {
        case 'haewon':
          cardImg.src = haewonCardPic
          break
        case 'pecera':
          cardImg.src = peceraCardPic
          break
        case 'toothpaste':
          cardImg.src = toothpasteCardPic
          break
        default:
          cardImg.src = haewonCardPic
      }

      const rankImg = new Image()
      switch (rank) {
        case 'dropship':
          rankImg.src = dropshipPic
          break
        case 'junior':
          rankImg.src = juniorPic
          break
        case 'senior':
          rankImg.src = seniorPic
          break
        case 'vip':
          rankImg.src = vipPic
          break
        case 'supervip':
          rankImg.src = supervipPic
          break
        default:
          rankImg.src = dropshipPic
          break
      }

      const uploadImage = new Image()
      uploadImage.src = this.state.croppedImage

      Promise.all([
        new Promise(resolve => (cardImg.onload = () => resolve())),
        new Promise(resolve => (rankImg.onload = () => resolve())),
        new Promise(resolve => (uploadImage.onload = () => resolve()))
      ]).then(() => {
        ctx.drawImage(cardImg, 0, 0)
        ctx.drawImage(rankImg, 0, 0)
        ctx.drawImage(
          uploadImage,
          0,
          0,
          croppedImageInfo.width,
          croppedImageInfo.height,
          568,
          489,
          268,
          268
        )

        ctx.textAlign = 'center'
        ctx.fillStyle = 'white'
        ctx.font = '56px Helvet'
        ctx.fillText(idhw, 702, 396)

        ctx.fillStyle = '#333'
        ctx.font = '48px Helvet'
        ctx.fillText(name, 702, 816)

        let numLine = 0
        ctx.font = '36px Helvet'
        const centerText = 702
        const maxWidth = 400
        const startY = 872
        // count line
        if (fb != '') numLine += 1
        if (line != '') numLine += 1
        if (ig != '') numLine += 1
        if (tel != '') numLine += 1
        if (zone != '') numLine += countLineWrapText(ctx, zone, maxWidth)

        let lineHeight
        if (numLine <= 5) {
          ctx.font = '40px Helvet'
          lineHeight = 36
        } else if (numLine === 6) {
          ctx.font = '36px Helvet'
          lineHeight = 30
        } else {
          ctx.font = '32px Helvet'
          lineHeight = 24
        }

        let currentLine = 0
        if (fb != '') {
          ctx.fillText(
            `FB : ${fb}`,
            centerText,
            startY + lineHeight * currentLine,
            maxWidth
          )
          currentLine += 1
        }

        if (line != '') {
          ctx.fillText(
            `Line : ${line}`,
            centerText,
            startY + lineHeight * currentLine,
            maxWidth
          )
          currentLine += 1
        }

        if (ig != '') {
          ctx.fillText(
            `Instagram : ${ig}`,
            centerText,
            startY + lineHeight * currentLine,
            maxWidth
          )
          currentLine += 1
        }

        if (tel != '') {
          ctx.fillText(
            `Tel : ${tel}`,
            centerText,
            startY + lineHeight * currentLine,
            maxWidth
          )
          currentLine += 1
        }

        if (zone != '') {
          wrapText(
            ctx,
            `Zone : ${zone}`,
            centerText,
            startY + lineHeight * currentLine,
            maxWidth,
            lineHeight
          )
          currentLine += 1
        }

        console.log({ img: canvas.toDataURL() })

        document.getElementById('show-image').src = canvas.toDataURL()
        this.setState(() => ({ readyDownload: true }))

        canvas.toBlob(blob => {
          this.setState(() => ({ saveBlob: blob }))
          FileSaver.saveAs(blob, `hw_card_${Date.now()}.png`)
        })
      })
    } else {
      this.setState(() => ({ readyDownload: false }))
    }
  }

  saveCardImage = () => {
    FileSaver.saveAs(this.state.saveBlob, `hw_card_${Date.now()}.png`)
  }

  fields = () => [
    { label: 'รหัส', placeholder: 'H1234', name: 'idhw' },
    { label: 'ชื่อ', placeholder: 'สมหญิง ใจดี', name: 'name' },
    { label: 'FB', placeholder: 'Somying Jaidee', name: 'fb' },
    { label: 'Line', placeholder: 'somying.jaidee', name: 'line' },
    { label: 'IG', placeholder: 'igsomying', name: 'ig' },
    { label: 'Tel', placeholder: '089-999-9999', name: 'tel' },
    { label: 'Zone', placeholder: 'หมอชิต เกษตร ลาดพร้าว วังหิน', name: 'zone' }
  ]

  renderLogo = () => (
    <div style={{ marginTop: 16 }}>
      <Row>
        <Col
          xs={{ span: 12, offset: 6 }}
          md={{ span: 8, offset: 8 }}
          xl={{ span: 4, offset: 10 }}
        >
          <div className={`logo-${this.state.product}`} />
        </Col>
      </Row>
    </div>
  )

  render() {
    return (
      <div>
        <Row>
          <Col span={22} offset={1}>
            {this.renderLogo()}
            {this.renderSelectProduct()}
            {this.renderSelectPosition()}
            {this.fields().map(field => {
              return this.TextInput({ ...field })
            })}
            <div style={{ marginTop: 16 }}>
              <Row>
                {this.renderLabel('ภาพ')}
                <Col
                  xs={{ span: 18, offset: 1 }}
                  md={{ span: 12, offset: 1 }}
                  xl={{ span: 8, offset: 1 }}
                >
                  <input
                    type="file"
                    id="inputfile"
                    name="pic"
                    className="inputfile"
                    accept="image/*"
                    onChange={this.selectImage}
                  />
                  <label htmlFor="inputfile">
                    <strong>เลือกรูปภาพของคุณ</strong>
                  </label>
                  <div
                    style={{
                      display: this.state.fileSelected ? 'inline' : 'none'
                    }}
                  >
                    <span className="tick-mark">&#10004;</span>
                    <span>OK</span>
                  </div>
                </Col>
              </Row>
            </div>

            <div style={{ marginTop: 16, paddingBottom: 16 }}>
              <Row>
                {this.renderLabel('')}
                <Col
                  xs={{ span: 20, offset: 1 }}
                  md={{ span: 12, offset: 1 }}
                  xl={{ span: 8, offset: 1 }}
                  offset={1}
                >
                  <Button
                    className="my-btn"
                    disabled={!this.state.croppedImage}
                    type="primary"
                    icon="download"
                    onClick={this.generateCard}
                    size="large"
                  >
                    สร้างบัตร
                  </Button>
                  <Button
                    className="my-btn"
                    disabled={!this.state.saveBlob}
                    icon="download"
                    onClick={this.saveCardImage}
                    size="large"
                  >
                    บันทึกรูป
                  </Button>
                </Col>
              </Row>
            </div>
            <div
              style={{
                marginTop: 16,
                display: this.state.readyDownload ? 'block' : 'none'
              }}
            >
              <Row className="warning-text">
                <Col
                  xs={{ span: 22, offset: 1 }}
                  sm={{ span: 18, offset: 3 }}
                  md={{ span: 14, offset: 5 }}
                  xl={{ span: 10, offset: 7 }}
                >
                  <Alert
                    message="หากรูปบัตรไม่บันทึกอัตโนมัติ ให้ลองกดค้างที่รูปเพื่อบันทึก หากพบปัญหาการทำงานขัดข้อง กรุณาเปิดใน browser chrome"
                    type="warning"
                    showIcon
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <div
                    style={{
                      marginTop: 16,
                      visibility: this.state.readyDownload
                        ? 'visible'
                        : 'hidden'
                    }}
                  >
                    <Row>
                      <Col
                        xs={{ span: 22, offset: 1 }}
                        sm={{ span: 18, offset: 3 }}
                        md={{ span: 14, offset: 5 }}
                        xl={{ span: 10, offset: 7 }}
                      >
                        <img id="show-image" target="_blank" />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>

            <canvas id="canvas" height={1040} width={1040} />
          </Col>
        </Row>

        <Modal
          className="crop-modal"
          title="ปรับตำแหน่งรูปภาพ"
          visible={this.state.modalVisible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText="OK"
          cancelText="Cancel"
          maskClosable={false}
        >
          <div className="avatar-editor">
            <AvatarEditor
              ref={this.setImageEditorRef}
              image={this.state.fileSelected}
              width={150}
              height={150}
              border={20}
              color={[0, 0, 0, 0.7]} // RGBA
              scale={this.state.picScale}
              rotate={this.state.rotate}
            />
          </div>
          <div className="slider">
            <Slider
              defaultValue={20}
              onChange={this.changeZoom}
              tipFormatter={null}
            />
          </div>
          <Button onClick={this.rotateClockwise}>หมุนรูป</Button>
        </Modal>
      </div>
    )
  }
}

export default DetailForms



// WEBPACK FOOTER //
// ./src/components/DetailForms.js